module.exports = __webpack_public_path__ + "img/places-work-plans.17cd2dc8.svg";